export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/global-placeholder@2x.png";